import { get, post } from './API';
import DriverExpensesService from './DriverExpensesService';
import { announceTripClaimsChanged } from '../Utils/tripClaims';

/**
 * Trip claims — receipts and overtime waiting for staff review.
 *
 * The ONE review path every screen uses (the booking's Driver Events tab,
 * the Order Details banner, the Trip claims page): a receipt is decided
 * through /operators/portal-expenses as before, an overtime entry through
 * /operators/trip-claims. Either way the badges are told to re-read.
 */
const unwrap = (response) => response?.data?.data ?? response?.data;

const TripClaimsService = {
  // GET /operators/trip-claims?type&from&to&operatorId&bookingId
  // → { claims: [{ kind: 'receipt'|'overtime', id, booking_id,
  //      booking_reference, booking_status, trip_date, filed_at,
  //      operator_id, operator_name, submitted_by, expense?, overtime? }],
  //    counts: { receipts, overtime, total }, capped }, oldest trip first.
  //    `capped`: more wait than one page holds — narrow it with the filters.
  async list(params = {}) {
    const query = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''));
    const data = unwrap(await get('operators/trip-claims', query));
    return {
      claims: Array.isArray(data?.claims) ? data.claims : [],
      counts: data?.counts || { receipts: 0, overtime: 0, total: 0 },
      capped: Boolean(data?.capped),
    };
  },

  // GET /operators/trip-claims?summary=true → { receipts, overtime, total }.
  async summary() {
    const data = unwrap(await get('operators/trip-claims', { summary: 'true' }));
    return data?.counts || { receipts: 0, overtime: 0, total: 0 };
  },

  // decision: 'approved' | 'rejected'. `orderLine` ({ operator_id }) approves
  // AND files the cost in one call; omitted, the cost is absorbed and only the
  // decision is written. Returns the updated expense.
  async reviewReceipt(expenseId, decision, orderLine) {
    const updated = await DriverExpensesService.review(expenseId, decision, orderLine);
    announceTripClaimsChanged();
    return updated;
  },

  // decision: 'approved' | 'rejected'. Returns the updated overtime entry.
  async reviewOvertime(bookingId, overtimeId, decision) {
    const updated = unwrap(await post('operators/trip-claims', {
      booking_id: bookingId,
      overtime_id: overtimeId,
      decision,
    }));
    announceTripClaimsChanged();
    return updated;
  },
};

export default TripClaimsService;
